<template>
  <div id="tooltip-card">

    <!-- Customs -->
    <div v-if="showTooltip && tooltipParams[0].name == 'Bovinos'">
      <TooltipBovines :tooltipParams="tooltipParams" :showTooltip="showTooltip"></TooltipBovines>
    </div>

    <div v-else-if="(showTooltip && tooltipParams[0].name == 'Agrotóxico') || (showTooltip && tooltipParams[0].name == 'Cargas Difusas')">
      <tooltip-card-map-conservation class="mt-8" :tooltipParams="tooltipParams"
        :overlayLayerTooltipCard="overlayLayerTooltipCard"></tooltip-card-map-conservation>
    </div>

    <div v-else-if="showTooltip && tooltipParams[0].name == 'Índice de Conformidade de Enquadramento (ICE)'">
      <tooltip-ice :tooltipParams="tooltipParams" :showTooltip="showTooltip"></tooltip-ice>
    </div>

    <div v-else-if="showTooltip && tooltipParams[0].name.toLowerCase() == 'disponibilidade hídrica'">
      <tooltip-water-availability :tooltipParams="tooltipParams" :showTooltip="showTooltip"></tooltip-water-availability>
    </div>
    
    <div v-else-if="showTooltip && tooltipParams[0].id == 21008">
      <tooltip-pocos :tooltipParams="tooltipParams" :showTooltip="showTooltip"></tooltip-pocos>
    </div>

    <!-- Default -->
    <v-card v-else-if="showTooltip"
      class="pa-2 mb-6 primary darken-2 overlay-reservoir-center"
      max-width="420"
    >
      <v-card-title>
        <v-row :align="showTooltip.label_subtitle ? 'start' : 'center'">
          <v-icon v-if="showTooltip.icon_params" class="pa-1 mr-2" size="18" color="white"
            :style="`border-radius: 50%;background-color: ${showTooltip.icon_params.background_color}`">{{
              showTooltip.icon_params.class }}</v-icon>
          <div>
            <h1 v-if="showTooltip.value_title" class="pa-0 ma-0 white--text tooltip-title">
              <span v-if="showTooltip.label_title">{{ showTooltip.label_title }}&nbsp;&nbsp;-&nbsp;&nbsp;</span>{{
                showTooltip.value_title }}
            </h1>
            <h1 v-else class="pa-0 ma-0 white--text tooltip-title">
              {{ showTooltip.name }}
            </h1>
            <h2 v-if="showTooltip.value_subtitle" class="mt-0 pa-0 ma-0 tooltip-subtitle">
              <span v-if="showTooltip.label_subtitle">{{ showTooltip.label_subtitle }}:&nbsp;&nbsp;</span>
              <span>{{ showTooltip.value_subtitle }}</span>
            </h2>
          </div>
        </v-row>
      </v-card-title>
      <v-card-text v-if="showTooltip.items.length" class="pa-0 ma-0">
        <div class="mt-1" v-for="(property, index2) in showTooltip.items" :key="index2">
          <v-icon class="mr-2" size="16" color="secondary lighten-1">{{
            property.icon_label ? property.icon_label : 'waves'
          }}</v-icon>
          <span class="white--text mr-1" style="font-weight: normal; font-size: 14px; line-height: 18px">{{ property.label
          }}:&ensp;</span>
          <strong v-if="property.value" class="white--text"
            style="font-weight: bold; font-size: 16px; line-height: 20px">{{ fixValue(property.value) }} {{
              property.suffix }}</strong>
          <strong v-else class="white--text" style="font-weight: bold; font-size: 16px; line-height: 20px">Em
            breve</strong>
        </div>
      </v-card-text>
      <v-card-text v-if="showTooltip.updatedAt">
        <v-row class="align-center justify-start">
          <v-icon class="ml-1 mr-3" color="white" size="16" left>restore</v-icon>
          <span class="white--text" style="
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 16px;
            ">
            Atualizado em {{ formatDate(showTooltip.updatedAt) }}
          </span>
        </v-row>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import moment from 'moment';
import TooltipBovines from '@/components/common/TooltipCardMap/TooltipBovines';
import TooltipCardMapConservation from '@/components/Conservation/TooltipCardMapConservation';
import TooltipIce from "@/components/common/TooltipCardMap/TooltipIce";
import TooltipWaterAvailability from "@/components/common/TooltipCardMap/TooltipWaterAvailability";
import TooltipPocos from "@/components/common/TooltipCardMap/TooltipPocos"
export default {
  name: 'TooltipCardMap',
  props: ['tooltipParams', 'overlayLayerTooltipCard',],
  components: {
    TooltipCardMapConservation,
    TooltipBovines,
    TooltipIce,
    TooltipWaterAvailability,
    TooltipPocos,
  },
  data: () => ({}),

  computed: {
    showTooltip() {
      let firstTooltip = undefined;
      if (this.tooltipParams.length) {
        firstTooltip = this.tooltipParams[0];
        for (const tooltipKey in this.tooltipParams) {
          if (this.tooltipParams[tooltipKey].zindex > firstTooltip.zindex) {
            firstTooltip = this.tooltipParams[tooltipKey];
          }
        }
      }
      return firstTooltip;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    fixValue(value) {
      if (this.showTooltip.name === 'Agrotóxico') {
        return (
          (value * 1000).toLocaleString('pt-BR', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          }) + ' kg/ano'
        );
      }
      return value;
    },
  },
};
</script>

<style scoped>
.tooltip {
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  opacity: 0.8;
  position: absolute;
  transition: 0.5s all ease;
  transition-delay: 0.5s;
  z-index: 1000;
}

hr.solid {
  border-top: 3px solid #fff;
}

.tooltip-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}

.tooltip-subtitle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
}
</style>
